import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import Head from 'next/head';
import { getFavIcon } from '../utils/getFavIcon';

/**
 * Full-page, non-interactive "No Photos Here" splash. Presentational only: no
 * data fetching, no routing, no nav/branding. Copy, title, and image are
 * overridable so the same layout serves the index splash (defaults) and the
 * trashed-event preset (EventUnavailable) without duplicating markup.
 *
 * @param {object} props
 * @param {string} [props.title='No photos here'] - Document (browser tab) title.
 * @param {string} [props.heading='No Photos Here'] - Bold heading text.
 * @param {string} [props.body='Contact your rental company for more information'] - Subtitle / body copy.
 * @param {string} [props.image='/static/frame.svg'] - Path to the frame illustration.
 * @returns {JSX.Element}
 */
export const NoPhotosHere = ({
  title = 'No photos here',
  heading = 'No Photos Here',
  body = 'Contact your rental company for more information',
  image = '/static/frame.svg',
}) => (
  <div className="splashpage">
    <Head>
      <title>{title}</title>
      {getFavIcon('blank')}
    </Head>
    <Container fluid={true}>
      <Row className="justify-content-center">
        <Col xs="12" md="7" lg="4">
          <div className="imagecontainer">
            <img src={image} alt="" />
          </div>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col xs="12" md="7">
          <div className="titles">
            <div className="title">{heading}</div>
            <div className="subtitle">{body}</div>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
);

export default NoPhotosHere;
